import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

const MARKETPLACE_ADMIN_ROLES = new Set([
  'super_admin',
  'admin',
  'admin_marketplace',
  'admin_koperasi',
]);

export const marketplaceAdminGuard: CanActivateFn = () => {
  const role = inject(AuthService).currentUser()?.role;
  if (role && MARKETPLACE_ADMIN_ROLES.has(role)) return true;
  inject(Router).navigate(['/admin']);
  return false;
};
